import React from "react"
/**
 * Version with nightly keep as is. Normal version remove the +commit and so on...
 * //Something like like v0.5.11-nightly.2019.6.25+commit.1cc84753
 * @param version {string} Something like like v0.5.11-nightly.2019.6.25+commit.1cc84753
 * @returns {string} Something like like v0.5.11
 */
export default function normalizeCompilerVersion(version) {
  return version.replace(/\++.*/, "")
}
